import { Text } from '@wartek-id/text-v1'

import useContentContext from 'app/KinerjaPage/hooks/useContentContext'
import TabTugasPokok from 'app/KinerjaPage/pages/Perencanaan/TabTugasPokok'
import TabPengembanganKompetensi from 'app/KinerjaPage/pages/Perencanaan/TabPengembanganKompetensi'
import PanelKinerja from 'app/KinerjaPage/components/PanelKinerja'
import TabPerilakuKerja from 'app/KinerjaPage/pages/PerencanaanApproved/TabPerilakuKerja'
import TabContentHeader from 'app/KinerjaPage/pages/PerencanaanApproved/TabContentHeader'
import { assetUrl } from 'utils/url'

import type { Kinerja } from 'types/kinerja'

interface MergedKinerjaPerencanaanApprovedAppProps {
  skp: Kinerja
  isDeleteSKPEnabled?: boolean
}

function FlatKinerjaPerencanaanApprovedView({
  skp,
  isDeleteSKPEnabled = false,
}: MergedKinerjaPerencanaanApprovedAppProps) {
  const { contentPraktikPembelajaran } = useContentContext()

  const selectedIndikator =
    contentPraktikPembelajaran
      .flatMap((dimensi) => dimensi.indikator)
      .find((indikator) => indikator.id === skp.reviewPraktikPembelajaran) ??
    null

  return (
    <>
      <div className="p-9 pb-0">
        <div className="flex flex-col gap-9">
          {skp.status === 'APPROVED' && <TabContentHeader />}
        </div>
      </div>

      <div className="flex flex-col gap-4 py-9">
        <TabTugasPokok
          reviewMode
          hideFooter
          customHeader={() => (
            <div className="flex gap-3 items-center">
              <img
                src={assetUrl('/illustrations/img-badge-star-ribbon-pro.png')}
                className="flex-shrink-0 flex-grow-0"
                alt=""
                width={52}
                height={52}
              />
              <Text variant="heading-sm">Pelaksanaan Tugas Pokok</Text>
            </div>
          )}
          skp={skp}
          className="!py-0"
        />
        <div className="px-9">
          <div className="flex gap-3 items-center mb-4">
            <img
              src={assetUrl('/illustrations/img-badge-star.png')}
              className="flex-shrink-0 flex-grow-0"
              alt=""
              width={52}
              height={52}
            />
            <Text variant="heading-sm">Praktik Kinerja</Text>
          </div>

          <PanelKinerja
            number={1}
            label=""
            kinerja={selectedIndikator}
            showDetails={false}
          />
        </div>
        <TabPengembanganKompetensi
          reviewMode
          hideFooter
          customHeader={() => (
            <div className="flex gap-3 items-center mb-4">
              <img
                src={assetUrl('/illustrations/img-document.png')}
                className="flex-shrink-0 flex-grow-0"
                alt=""
                width={52}
                height={52}
              />
              <Text variant="heading-sm">Pengembangan Kompetensi</Text>
            </div>
          )}
          skp={skp}
          className="!py-0"
        />
        <div className="px-9">
          <Text variant="heading-sm">Perilaku Kerja</Text>
        </div>
        <TabPerilakuKerja
          skp={skp}
          isDeleteSKPEnabled={isDeleteSKPEnabled}
          showHeader={false}
          className="!py-0"
        />
      </div>
    </>
  )
}

export default FlatKinerjaPerencanaanApprovedView
